/* import __COLOCATED_TEMPLATE__ from './sent.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let MagicLinkSentComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipass-storage'), _dec3 = service('ember-multipass-tracking'), _dec4 = service('ember-multipassfe-client'), _class = class MagicLinkSentComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor2, this);
    _initializerDefineProperty(this, "logger", _descriptor3, this);
    _initializerDefineProperty(this, "storage", _descriptor4, this);
    _initializerDefineProperty(this, "tracking", _descriptor5, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor6, this);
    _initializerDefineProperty(this, "isResending", _descriptor7, this);
    _initializerDefineProperty(this, "showResendDialog", _descriptor8, this);
    this.logger.addComponentBreadcrumb('MagicLinkSentComponent');
    this.tracking.trackPageView({
      pageTitle: 'Risk Magic Link Sent'
    });
  }
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  get email() {
    return this.multipassfeClient.accountInformation?.email_address || '';
  }
  get supportUrl() {
    return this.multipassfeClient.constants.SUPPORT_URL;
  }
  async resendMagicLink() {
    if (this.isResending) return;
    if (!this.email) {
      this.multipassfeClient.redirectToLogin();
      return;
    }
    this.isResending = true;
    try {
      this.tracking.trackButtonClick({
        elementIdentifier: 'Resend Risk Magic Link',
        elementType: 'Button'
      });
      await this.multipassfeClient.sendRiskMagicLink(this.email);
      this.showResendDialog = true;
    } catch (e) {
      this.logger.sentryError(e);
      this.marketToasts.critical(this.intl.t(this.tPrefix + 'magic_link.resend_error'));
    } finally {
      this.isResending = false;
    }
  }
  closeResendDialog() {
    this.showResendDialog = false;
  }
  backToSignIn() {
    this.tracking.trackButtonClick({
      elementIdentifier: 'Back to Sign In (from Risk Magic Link Sent)',
      elementType: 'Button'
    });
    this.storage.clearRiskMagicLinkSent();
    this.multipassfeClient.redirectToUrl('/logout');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "storage", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "tracking", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isResending", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "showResendDialog", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "resendMagicLink", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resendMagicLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeResendDialog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeResendDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "backToSignIn", [action], Object.getOwnPropertyDescriptor(_class.prototype, "backToSignIn"), _class.prototype), _class);
export { MagicLinkSentComponent as default };